import React, { useState } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import jsPDF from "jspdf"
import autoTable from "jspdf-autotable"
import Swal from "sweetalert2"

const cbseLogo = "/images/assets/cbse_logo.png"
const schoolLogo = "/images/assets/sps_logo.png"

const SCHOOL = {
  name: "South Point School, Guwahati",
  established: "Established Year 1960",
  affiliation: "Affiliated to CBSE New Delhi, Affiliation No. : 230044",
  address: "21, Barsapara Road, Guwahati - 781018",
  phone: "+91 97060 12121",
  email: "helpdesk@spsghy.co.in",
  website: "www.spsghy.co.in",
}

const gradesList = ["A1", "A2", "B1", "B2", "C1", "C2", "D1", "D2", "E"]
const colorsList = [
  [192, 57, 43], [230, 126, 34], [243, 156, 18], [39, 174, 96],
  [22, 160, 133], [41, 128, 185], [26, 82, 118], [74, 35, 90], [26, 26, 26]
]

const marksheetFormats = [
  { value: "ma_pre1", label: "MA to Pre-1", disabled: false },
  { value: "class9_annual", label: "Class 9 Annual", disabled: false },
  { value: "class11_12_annual", label: "Class 11–12 Annual", disabled: true },
  { value: "class11_12_nopractical", label: "Class 11–12 Without Practical", disabled: true },
  { value: "retest_marksheet", label: "Re-Test Marksheet", disabled: false }
]

const staticMaPre1Data = {
  student_info: {
    st_name: "AARAV KASHYAP",
    father_name: "MR. BIJOY KASHYAP",
    mother_name: "MS. RINKI KASHYAP",
    address: "ZOO ROAD, TINIALI, GUWAHATI, ASSAM,, 781024",
    st_code: "023561",
    st_class: "MA",
    st_sec: "A",
    roll: "12",
    dob: "15/09/2021",
    profile_pic: ""
  },
  session_name: "2025-2026",
  print_date: "8/6/2026",
  academic_year: "2025-2026",
  general_observations_t1: [
    { name: "Activities taken part", grade: "A" },
    { name: "General Appearance and Grooming", grade: "A+" },
    { name: "Behaviour and Conduct", grade: "A" },
    { name: "Personality", grade: "B+" },
    { name: "Discipline", grade: "A" },
    { name: "Co-Operation", grade: "B+" }
  ],
  attendance_t1: { present: 85, total: 90 },
  remarks_t1: "Very active, curious, and well behaved student.",
  general_observations_t2: [
    { name: "Activities taken part", grade: "A+" },
    { name: "General Appearance and Grooming", grade: "A+" },
    { name: "Behaviour and Conduct", grade: "A+" },
    { name: "Personality", grade: "A" },
    { name: "Discipline", grade: "A" },
    { name: "Co-Operation", grade: "A" }
  ],
  attendance_t2: { present: 88, total: 92 },
  remarks_t2: "Excellent progress throughout the academic year. Highly cooperative.",
  promoted_to_class: "Pre-1",
  evaluations: [
    { slno: "01", name: "English (Oral)", t1: "A+", t2: "A+" },
    { slno: "02", name: "English (Written)", t1: "A", t2: "A+" },
    { slno: "03", name: "Number (Oral)", t1: "A+", t2: "A+" },
    { slno: "04", name: "Number (Written)", t1: "A+", t2: "A" },
    { slno: "05", name: "2nd Language (Oral)", t1: "B+", t2: "A" },
    { slno: "06", name: "2nd Language (Written)", t1: "B", t2: "B+" },
    { slno: "07", name: "General Knowledge (Oral)", t1: "A", t2: "A+" },
    { slno: "08", name: "Recitation", t1: "A+", t2: "A+" },
    { slno: "09", name: "Observation of surroundings", t1: "A", t2: "A" },
    { slno: "10", name: "Recognition of sound", t1: "A+", t2: "A+" },
    { slno: "11", name: "Sensorial Presentation", t1: "A", t2: "A+" },
    { slno: "12", name: "Drawing and Colouring", t1: "A+", t2: "A+" },
    { slno: "13", name: "Apparatus Presentation", t1: "A", t2: "A" },
    { slno: "14", name: "Exercises of Practical Life", t1: "A+", t2: "A+" },
    { slno: "15", name: "Picture Conversation", t1: "A", t2: "A+" }
  ]
}


const staticReTestData = {
  student_info: {
    st_name: "AMRITA DEY",
    father_name: "MR. AMIT DEY",
    mother_name: "MS. TUMPA DEY",
    address: "NEW COLONY, SHYAMA PRASAD PALLY, HOJAI, ASSAM,, 782447",
    st_code: "021161",
    st_class: "11",
    st_sec: "B",
    dob: "30/06/2007",
    profile_pic: ""
  },
  session_name: "2024-2025",
  print_date: "8/6/2026",
  subjects: [
    { slno: 1, name: "ENGLISH CORE", code: "301", full_pract: 20, full_theory: 80, pass_pract: 6, pass_theory: 26, obtain_pract: 10, obtain_theory: 35, obtain_total: 45 },
    { slno: 2, name: "PHYSICS", code: "042", full_pract: 30, full_theory: 70, pass_pract: 9, pass_theory: 23, obtain_pract: 22, obtain_theory: "30 RT", obtain_total: 52 },
    { slno: 3, name: "CHEMISTRY", code: "043", full_pract: 30, full_theory: 70, pass_pract: 9, pass_theory: 23, obtain_pract: 15, obtain_theory: "18 RT", obtain_total: 33 },
    { slno: 4, name: "BIOLOGY", code: "044", full_pract: 30, full_theory: 70, pass_pract: 9, pass_theory: 23, obtain_pract: 20, obtain_theory: 13, obtain_total: 33 },
    { slno: 5, name: "PSYCHOLOGY", code: "037", full_pract: 30, full_theory: 70, pass_pract: 9, pass_theory: 23, obtain_pract: 24, obtain_theory: 17, obtain_total: 41 },
    { slno: 6, name: "PHYSICAL EDU", code: "048", full_pract: 30, full_theory: 70, pass_pract: 9, pass_theory: 23, obtain_pract: 29, obtain_theory: 49, obtain_total: 78 }
  ],
  total_full_pract: 170,
  total_full_theory: 430,
  total_obtain_pract: 120,
  total_obtain_theory: 162,
  total_obtain_total: 282,
  first_attempt_note: "First Attempt Marks obtain in : PHYSICS [ 5 ] CHEMISTRY [ 14 ]",
  co_scholastic: [
    { name: "Work Education (500)", grade: "B1" },
    { name: "Art Education (501)", grade: "A2" },
    { name: "Health And Physical Education (502)", grade: "A1" }
  ],
  subject_averages: [
    { name: "ENGLISH CORE", average: 47 },
    { name: "BIOLOGY", average: 19 },
    { name: "CHEMISTRY", average: 18 },
    { name: "PHYSICS", average: 20 },
    { name: "PSYCHOLOGY", average: 33 },
    { name: "PHYSICAL EDU", average: 46 }
  ],
  marks_percentage: {
    practical: "71%",
    theory: "38%",
    overall: "47%"
  },
  attendance_percentage: {
    percentage: "78%",
    min_required: "75%"
  },
  remarks: ""
}

const staticClass9Data = {
  student_info: {
    st_name: "AYANUDDIN AHMED",
    father_name: "MR. SABIR UDDIN AHMED",
    mother_name: "MS. NASIMA BEGUM",
    address: "ATHGAON, S J ROAD, , KAMRUP, , 781001",
    st_code: "017566",
    st_class: "9",
    st_sec: "AK",
    dob: "21/10/2010",
    profile_pic: ""
  },
  session_name: "2025-2026",
  print_date: "8/6/2026",
  subjects: [
    { slno: 1, name: "ENGLISH", code: "184", periodic: 5, notebook: 3, enrich: 3, annual: 31, total: 42, grade: "D2" },
    { slno: 2, name: "ASSAMESE", code: "014", periodic: 5, notebook: 4, enrich: 4, annual: 21, total: 34, grade: "D2" },
    { slno: 3, name: "MATHEMATICS", code: "241", periodic: 1, notebook: 2, enrich: 2, annual: 20, total: 25, grade: "E" },
    { slno: 4, name: "SOCIAL SCIENCE", code: "087", periodic: 6, notebook: 4, enrich: 4, annual: 20, total: 34, grade: "D2" },
    { slno: 5, name: "SCIENCE", code: "086", periodic: 6, notebook: 4, enrich: 4, annual: 19, total: 33, grade: "D2" },
    { slno: 6, name: "BANKING AND INSURANCE", code: "411", periodic: 6, notebook: 5, enrich: 4, annual: 22, total: 37, grade: "D2" }
  ],
  total_periodic: 29,
  total_notebook: 22,
  total_enrich: 21,
  total_annual: 133,
  total_total: 205,
  co_scholastic: [
    { name: "Work Education", grade: "" },
    { name: "Art Education", grade: "" },
    { name: "Health And Physical Education", grade: "" },
    { name: "Discipline", grade: "" }
  ],
  subject_averages: [
    { name: "ENGLISH", average: 62 },
    { name: "ASSAMESE", average: 53 },
    { name: "BENGALI", average: 62 },
    { name: "HINDI", average: 51 },
    { name: "MATHEMATICS", average: 46 },
    { name: "SOCIAL SCIENCE", average: 52 },
    { name: "SCIENCE", average: 38 },
    { name: "BANKING AND INSURANCE", average: 65 },
    { name: "INFORMATION TECHNOLOGY", average: 78 },
    { name: "PAINTING", average: 69 }
  ],
  promotion_status: "",
  attendance: {
    total_days: "184 days",
    present_days: "136 days",
    percentage: "74%"
  },
  remarks: ""
}

const GenerateTestMarksheet = () => {
  const [selectedFormat, setSelectedFormat] = useState("")
  const [showPreview, setShowPreview] = useState(false)

  const handleFormatChange = (e) => {
    const val = e.target.value
    setSelectedFormat(val)
    setShowPreview(false)
  }

  const handleGenerate = () => {
    if (!selectedFormat) {
      Swal.fire("Validation", "Please select a marksheet format.", "warning")
      return
    }

    const selected = marksheetFormats.find(f => f.value === selectedFormat)
    if (selected?.disabled) {
      Swal.fire(
        "Info",
        `The format "${selected.label}" is currently under development. Please select "Re-Test Marksheet" or "Class 9 Annual".`,
        "info"
      )
      return
    }

    setShowPreview(true)
  }

  const sd = selectedFormat === "class9_annual"
    ? staticClass9Data.student_info
    : selectedFormat === "ma_pre1"
    ? staticMaPre1Data.student_info
    : staticReTestData.student_info

  // ── Download PDF using jsPDF ──
  const handleDownload = () => {
    if (!selectedFormat) return

    const pSetFill = (d, col) => d.setFillColor(col[0], col[1], col[2])
    const pSetDraw = (d, col) => d.setDrawColor(col[0], col[1], col[2])
    const pSetFont = (d, col) => d.setTextColor(col[0], col[1], col[2])

    if (selectedFormat === "ma_pre1") {
      const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" })
      const mmW = 297
      const mmH = 210
      const M = 6
      
      const activeData = staticMaPre1Data

      // Page 1: Booklet Outer (Left: General Observations, Right: Cover & Student Info)
      // Draw Page 1 border
      pSetDraw(doc, [196, 154, 108]) // Gold/beige tone
      doc.setLineWidth(1.0)
      doc.rect(M, M, mmW - M*2, mmH - M*2)
      
      // Draw middle fold line
      pSetDraw(doc, [210, 190, 140])
      doc.line(mmW/2, M, mmW/2, mmH - M)
      
      // Left side: General Observations
      let colW = (mmW - M*2) / 2
      let lx = M + 4
      let ly = M + 6
      
      // Term 1 header
      pSetFill(doc, [196, 154, 108]) // Tan header
      doc.rect(lx, ly, colW - 8, 8, "F")
      pSetFont(doc, [255, 255, 255])
      doc.setFontSize(10)
      doc.setFont("helvetica", "bold")
      doc.text("GENERAL OBSERVATIONS TERM - 1", lx + 4, ly + 5.5)
      
      // General Observations Table (Term 1)
      let tableY = ly + 10
      doc.setFontSize(8)
      doc.setFont("helvetica", "normal")
      pSetFont(doc, [60, 60, 60])
      
      let rowsT1 = activeData.general_observations_t1
      rowsT1.forEach((row, i) => {
        let ry = tableY + i * 7
        // Row text
        pSetFont(doc, [40, 40, 40])
        doc.text(row.name, lx + 2, ry + 5)
        // Grade box
        pSetDraw(doc, [210, 190, 140])
        pSetFill(doc, [255, 253, 240])
        doc.rect(lx + colW - 18, ry + 1, 8, 5.5, "FD")
        pSetFont(doc, [125, 10, 10])
        doc.setFont("helvetica", "bold")
        doc.text(row.grade, lx + colW - 14, ry + 5, { align: "center" })
        doc.setFont("helvetica", "normal")
      })
      
      // Attendance & Remarks T1
      let attY = tableY + rowsT1.length * 7 + 4
      pSetFont(doc, [40, 40, 40])
      doc.text(`Attendance...........................................${activeData.attendance_t1.present} days out of ${activeData.attendance_t1.total}...........................................`, lx + 2, attY)
      doc.text(`Remarks........................................................................................................................................`, lx + 2, attY + 6)
      pSetFont(doc, [125, 10, 10])
      doc.text(activeData.remarks_t1, lx + 20, attY + 6)
      
      // Signatures T1
      let sigY = attY + 18
      pSetFont(doc, [60, 60, 60])
      doc.setFontSize(7.5)
      doc.text("Signature : Class Teacher", lx + 2, sigY)
      doc.text("Parent / Guardian", lx + colW / 2 - 12, sigY)
      doc.text("Principal", lx + colW - 20, sigY)
      
      // Term 2 Observations
      ly = M + 104
      pSetFill(doc, [196, 154, 108]) // Tan header
      doc.rect(lx, ly, colW - 8, 8, "F")
      pSetFont(doc, [255, 255, 255])
      doc.setFontSize(10)
      doc.setFont("helvetica", "bold")
      doc.text("GENERAL OBSERVATIONS TERM - 2", lx + 4, ly + 5.5)
      
      tableY = ly + 10
      let rowsT2 = activeData.general_observations_t2
      rowsT2.forEach((row, i) => {
        let ry = tableY + i * 7
        pSetFont(doc, [40, 40, 40])
        doc.setFont("helvetica", "normal")
        doc.setFontSize(8)
        doc.text(row.name, lx + 2, ry + 5)
        // Grade box
        pSetDraw(doc, [210, 190, 140])
        pSetFill(doc, [255, 253, 240])
        doc.rect(lx + colW - 18, ry + 1, 8, 5.5, "FD")
        pSetFont(doc, [125, 10, 10])
        doc.setFont("helvetica", "bold")
        doc.text(row.grade, lx + colW - 14, ry + 5, { align: "center" })
      })
      
      attY = tableY + rowsT2.length * 7 + 4
      pSetFont(doc, [40, 40, 40])
      doc.setFont("helvetica", "normal")
      doc.text(`Attendance...........................................${activeData.attendance_t2.present} days out of ${activeData.attendance_t2.total}...........................................`, lx + 2, attY)
      doc.text(`Remarks........................................................................................................................................`, lx + 2, attY + 6)
      pSetFont(doc, [125, 10, 10])
      doc.text(activeData.remarks_t2, lx + 20, attY + 6)
      pSetFont(doc, [40, 40, 40])
      doc.text(`Promoted to Class..................................................${activeData.promoted_to_class}..................................................`, lx + 2, attY + 12)
      
      sigY = attY + 22
      pSetFont(doc, [60, 60, 60])
      doc.setFontSize(7.5)
      doc.text("Signature : Class Teacher", lx + 2, sigY)
      doc.text("Parent / Guardian", lx + colW / 2 - 12, sigY)
      doc.text("Principal", lx + colW - 20, sigY)
      
      // Footer Note Page 1
      pSetFill(doc, [196, 154, 108])
      doc.rect(lx, mmH - M - 6, colW - 8, 6, "F")
      pSetFont(doc, [255, 255, 255])
      doc.setFontSize(7)
      doc.setFont("helvetica", "bold")
      doc.text("NOTE : Parents will return this card to the school duly signed and retained after Annual Examination.", lx + 4, mmH - M - 2)
      
      // Right side: Cover & Student Info
      let rx = mmW / 2 + 4
      ly = M + 6
      
      // Header: South Point School, Guwahati
      pSetFont(doc, [125, 10, 10]) // Red
      doc.setFontSize(16)
      doc.setFont("georgia", "bold")
      doc.text("South Point School, Guwahati", rx + colW/2 - 4, ly + 6, { align: "center" })
      
      pSetFont(doc, [60, 60, 60])
      doc.setFontSize(7)
      doc.setFont("helvetica", "normal")
      doc.text("21, Barsapara Road, Guwahati - 781 018", rx + colW/2 - 4, ly + 10, { align: "center" })
      doc.text("Affiliated to CBSE New Delhi, Affiliation No. : 230044", rx + colW/2 - 4, ly + 13.5, { align: "center" })
      doc.text("Phone: +91 97060-12121, +91 361-2475977, Fax: +91 361 2475977 Ext 333,", rx + colW/2 - 4, ly + 17, { align: "center" })
      doc.text("email: principal@spsghy.com / southpointguwahati@gmail.com, Web site: www.spsghy.com", rx + colW/2 - 4, ly + 20.5, { align: "center" })
      
      // Thick red band
      pSetFill(doc, [125, 10, 10])
      doc.rect(rx, ly + 23, colW - 8, 2.5, "F")
      
      // Star Logo Simulation
      pSetDraw(doc, [125, 10, 10])
      doc.setLineWidth(0.4)
      let logoX = rx + colW/2 - 4
      let logoY = ly + 46
      
      // School star logo sketch / text
      doc.circle(logoX, logoY, 11, "D")
      pSetFont(doc, [125, 10, 10])
      doc.setFontSize(5.5)
      doc.setFont("helvetica", "bold")
      doc.text("SOUTH POINT", logoX, logoY - 4, { align: "center" })
      doc.setFontSize(8)
      doc.text("★", logoX, logoY + 1.5, { align: "center" })
      doc.setFontSize(5.5)
      doc.text("GUWAHATI", logoX, logoY + 6, { align: "center" })
      
      // Progress Report Title
      pSetFont(doc, [125, 10, 10])
      doc.setFontSize(20)
      doc.setFont("georgia", "bold")
      doc.text("PROGRESS REPORT", rx + colW/2 - 4, ly + 68, { align: "center" })
      
      doc.setFontSize(11)
      doc.text("Montessori Section ( MA to Pre1 )", rx + colW/2 - 4, ly + 75, { align: "center" })
      
      pSetFont(doc, [0, 0, 0])
      doc.setFontSize(12)
      doc.text(`ACADEMIC YEAR :  ${activeData.academic_year}`, rx + 6, ly + 100)
      
      // Student details box
      let boxY = ly + 112
      let boxW = colW - 8
      let boxH = 58
      pSetFill(doc, [255, 253, 230]) // beige tint background
      pSetDraw(doc, [125, 10, 10])
      doc.setLineWidth(0.8)
      doc.rect(rx, boxY, boxW, boxH, "FD")
      doc.setLineWidth(0.3)
      
      let bx = rx + 4
      let by = boxY + 6
      pSetFont(doc, [0, 0, 0])
      doc.setFontSize(9)
      doc.setFont("helvetica", "bold")
      
      doc.text("Student Code", bx, by)
      doc.text(":", bx + 42, by)
      // Code grid boxes
      let codeStr = activeData.student_info.st_code || ""
      for (let i = 0; i < 6; i++) {
        doc.rect(bx + 46 + i*6, by - 3.8, 5.5, 5, "D")
        if (codeStr[i]) {
          doc.text(codeStr[i], bx + 48.7 + i*6, by, { align: "center" })
        }
      }
      
      const drawInfoRow = (lbl, val, rowY) => {
        doc.text(lbl, bx, rowY)
        doc.text(":", bx + 42, rowY)
        doc.rect(bx + 46, rowY - 3.8, boxW - 54, 5, "D")
        pSetFont(doc, [60, 60, 60])
        doc.text(val || "", bx + 48, rowY)
        pSetFont(doc, [0, 0, 0])
      }
      
      drawInfoRow("Student Name", activeData.student_info.st_name, by + 8)
      drawInfoRow("Class", activeData.student_info.st_class, by + 16)
      drawInfoRow("Section", activeData.student_info.st_sec, by + 24)
      drawInfoRow("Roll", activeData.student_info.roll, by + 32)
      drawInfoRow("Specimen Signature of Parent/Guardian", "", by + 42)
      
      // Page 2: Inside Spread (Evaluation Records Term 1 & Term 2 side-by-side)
      doc.addPage()
      
      // Draw Page 2 border
      pSetDraw(doc, [196, 154, 108])
      doc.rect(M, M, mmW - M*2, mmH - M*2)
      // Middle fold line
      doc.line(mmW/2, M, mmW/2, mmH - M)
      
      // Grade chart header
      pSetDraw(doc, [196, 154, 108])
      pSetFill(doc, [255, 253, 240])
      doc.rect(M + 4, M + 4, mmW - M*2 - 8, 9, "FD")
      pSetFont(doc, [125, 10, 10])
      doc.setFontSize(8)
      doc.setFont("helvetica", "bold")
      doc.text("GRADE CHART :", M + 6, M + 10)
      
      pSetFont(doc, [0, 0, 0])
      doc.text("A+ : EXCELLENT       A : VERY GOOD       B+ : GOOD       B : AVERAGE       C : SCOPE FOR IMPROVEMENT", M + 34, M + 10)
      
      // EVALUATION RECORDS
      let colLeftX = M + 4
      let colRightX = mmW/2 + 4
      let contentY = M + 20
      
      pSetFill(doc, [196, 154, 108])
      doc.rect(colLeftX, contentY, colW - 8, 6, "F")
      doc.rect(colRightX, contentY, colW - 8, 6, "F")
      
      pSetFont(doc, [255, 255, 255])
      doc.setFontSize(8.5)
      doc.text("EVALUATION RECORD : TERM - 1", colLeftX + 4, contentY + 4)
      doc.text("EVALUATION RECORD : TERM - 2", colRightX + 4, contentY + 4)
      
      // Headers of columns
      pSetFill(doc, [196, 154, 108])
      let subY = contentY + 6
      doc.rect(colLeftX, subY, colW - 8, 5, "F")
      doc.rect(colRightX, subY, colW - 8, 5, "F")
      pSetFont(doc, [255, 255, 255])
      doc.setFontSize(7)
      doc.text("AREAS OF ASSESSMENT", colLeftX + 2, subY + 3.5)
      doc.text("GRADE", colLeftX + colW - 18, subY + 3.5)
      doc.text("AREAS OF ASSESSMENT", colRightX + 2, subY + 3.5)
      doc.text("GRADE", colRightX + colW - 18, subY + 3.5)
      
      // 15 rows of evaluation
      let rowH = 10.5
      let evRows = activeData.evaluations
      evRows.forEach((row, i) => {
        let ry = subY + 5 + i * rowH
        
        // Horizontal separation lines
        pSetDraw(doc, [230, 220, 190])
        doc.line(colLeftX, ry + rowH, colLeftX + colW - 8, ry + rowH)
        doc.line(colRightX, ry + rowH, colRightX + colW - 8, ry + rowH)
        
        // Term 1 items
        pSetFont(doc, [40, 40, 40])
        doc.setFont("helvetica", "normal")
        doc.setFontSize(7.5)
        doc.text(`${row.slno}. ${row.name}`, colLeftX + 2, ry + 6.5)
        
        // Grade box T1
        pSetDraw(doc, [210, 190, 140])
        pSetFill(doc, [255, 253, 240])
        doc.rect(colLeftX + colW - 18, ry + 2, 8, 6.5, "FD")
        pSetFont(doc, [125, 10, 10])
        doc.setFont("helvetica", "bold")
        doc.text(row.t1, colLeftX + colW - 14, ry + 6.5, { align: "center" })
        
        // Term 2 items
        pSetFont(doc, [40, 40, 40])
        doc.setFont("helvetica", "normal")
        doc.text(`${row.slno}. ${row.name}`, colRightX + 2, ry + 6.5)
        
        // Grade box T2
        pSetDraw(doc, [210, 190, 140])
        pSetFill(doc, [255, 253, 240])
        doc.rect(colRightX + colW - 18, ry + 2, 8, 6.5, "FD")
        pSetFont(doc, [125, 10, 10])
        doc.setFont("helvetica", "bold")
        doc.text(row.t2, colRightX + colW - 14, ry + 6.5, { align: "center" })
      })
      
      // Bottom highlight strip
      pSetFill(doc, [196, 154, 108])
      doc.rect(colLeftX, subY + 5 + 15 * rowH, colW - 8, 4, "F")
      doc.rect(colRightX, subY + 5 + 15 * rowH, colW - 8, 4, "F")
      
      doc.save(`Montessori_Section_Progress_Report_${activeData.student_info.st_name.replace(/\s+/g, "_")}.pdf`)
      return
    }

    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" })
    const mmW = 210
    const mmH = 297
    const M = 8 // margin

    const docActiveData = selectedFormat === "class9_annual" ? staticClass9Data : staticReTestData
    const activeData = docActiveData

    const C = {
      maroon: [125, 10, 10],
      navyBlue: [2, 2, 85],
      greenBorder: [58, 125, 68],
      black: [0, 0, 0],
      white: [255, 255, 255],
      grey: [240, 240, 240],
      darkGrey: [80, 80, 80],
      orange: [224, 112, 32]
    }

    // Outer green border
    pSetDraw(doc, C.greenBorder)
    doc.setLineWidth(1.2)
    doc.rect(M, M, mmW - M * 2, mmH - M * 2)

    let y = M + 2

    pSetFont(doc, C.black)
    doc.setFontSize(7)
    doc.setFont("helvetica", "normal")
    doc.text(`Session : ${activeData.session_name}`, M + 2, y + 2)
    doc.text(`Print Date : ${activeData.print_date}`, mmW - M - 2, y + 2, { align: "right" })

    y += 5

    // School Header Box
    pSetFill(doc, C.maroon)
    doc.rect(M, y, mmW - M * 2, 22, "F")
    pSetFont(doc, C.white)
    doc.setFontSize(7)
    doc.text(SCHOOL.established, mmW / 2, y + 4, { align: "center" })
    doc.setFontSize(16)
    doc.setFont("helvetica", "bold")
    doc.text(SCHOOL.name, mmW / 2, y + 15, { align: "center" })

    y += 22

    // Info Strip
    pSetFont(doc, C.black)
    doc.setFontSize(6.5)
    doc.setFont("helvetica", "bold")
    doc.text(SCHOOL.affiliation, mmW / 2, y + 3, { align: "center" })
    pSetFont(doc, C.maroon)
    doc.text("Address : ", mmW / 2 - 42, y + 7)
    pSetFont(doc, C.black)
    doc.setFont("helvetica", "normal")
    doc.text(SCHOOL.address, mmW / 2 - 30, y + 7)
    pSetFont(doc, C.maroon)
    doc.setFont("helvetica", "bold")
    doc.text("Phone : ", mmW / 2 + 25, y + 7)
    pSetFont(doc, C.black)
    doc.setFont("helvetica", "normal")
    doc.text(SCHOOL.phone, mmW / 2 + 35, y + 7)

    doc.setFontSize(6)
    pSetFont(doc, C.maroon)
    doc.setFont("helvetica", "bold")
    doc.text("Email : ", mmW / 2 - 38, y + 11)
    pSetFont(doc, C.black)
    doc.setFont("helvetica", "normal")
    doc.text(SCHOOL.email, mmW / 2 - 28, y + 11)
    pSetFont(doc, C.maroon)
    doc.setFont("helvetica", "bold")
    doc.text("Website : ", mmW / 2 + 8, y + 11)
    pSetFont(doc, C.black)
    doc.setFont("helvetica", "normal")
    doc.text(SCHOOL.website, mmW / 2 + 20, y + 11)

    // Logo Placeholders
    doc.setLineWidth(0.3)
    pSetDraw(doc, [200, 200, 200])
    doc.rect(M + 2, y + 1, 14, 14)
    doc.rect(mmW - M - 16, y + 1, 14, 14)
    pSetFont(doc, C.darkGrey)
    doc.setFontSize(5)
    doc.text("CBSE Logo", M + 9, y + 8.5, { align: "center" })
    doc.text("School Logo", mmW - M - 9, y + 8.5, { align: "center" })

    y += 15

    // Student Details Title Box
    pSetFill(doc, C.maroon)
    doc.rect(M, y, 22, 5, "F")
    pSetFont(doc, C.white)
    doc.setFontSize(7)
    doc.setFont("helvetica", "bold")
    doc.text("Student Details", M + 2, y + 3.5)

    y += 5

    // Student Details Box Border
    pSetDraw(doc, [170, 170, 170])
    doc.setLineWidth(0.2)
    doc.rect(M, y, mmW - M * 2, 28)

    // Details Text
    pSetFont(doc, C.black)
    doc.setFontSize(8)
    
    let dy = y + 5
    doc.text(`Student's Name  : `, M + 3, dy)
    doc.setFont("helvetica", "bold")
    doc.text(activeData.student_info.st_name, M + 26, dy)

    doc.setFont("helvetica", "normal")
    doc.text(`Code : `, mmW / 2 + 10, dy)
    doc.setFont("helvetica", "bold")
    doc.text(activeData.student_info.st_code, mmW / 2 + 22, dy)

    dy += 5.5
    doc.setFont("helvetica", "normal")
    doc.text(`Father's Name   : `, M + 3, dy)
    doc.setFont("helvetica", "bold")
    doc.text(activeData.student_info.father_name, M + 26, dy)

    doc.setFont("helvetica", "normal")
    doc.text(`Class : `, mmW / 2 + 10, dy)
    doc.setFont("helvetica", "bold")
    doc.text(activeData.student_info.st_class, mmW / 2 + 22, dy)

    dy += 5.5
    doc.setFont("helvetica", "normal")
    doc.text(`Mother's Name   : `, M + 3, dy)
    doc.setFont("helvetica", "bold")
    doc.text(activeData.student_info.mother_name, M + 26, dy)

    doc.setFont("helvetica", "normal")
    doc.text(`Section : `, mmW / 2 + 10, dy)
    doc.setFont("helvetica", "bold")
    doc.text(activeData.student_info.st_sec, mmW / 2 + 22, dy)

    dy += 5.5
    doc.setFont("helvetica", "normal")
    doc.text(`Address : `, M + 3, dy)
    doc.setFont("helvetica", "bold")
    const splitAddr = doc.splitTextToSize(activeData.student_info.address, 70)
    doc.text(splitAddr, M + 26, dy)

    doc.setFont("helvetica", "normal")
    doc.text(`Date of Birth : `, mmW / 2 + 10, dy)
    doc.setFont("helvetica", "bold")
    doc.text(activeData.student_info.dob, mmW / 2 + 28, dy)

    // Student Photo Box
    doc.rect(mmW - M - 20, y + 2, 16, 20)
    pSetFont(doc, C.darkGrey)
    doc.setFontSize(6)
    doc.text(activeData.student_info.profile_pic ? "Photo" : "No Photo Available", mmW - M - 12, y + 12, { align: "center", maxWidth: 14 })

    y += 32

    // Report Card Title Strip
    pSetFill(doc, [125, 80, 50])
    doc.rect(M, y, mmW - M * 2, 7, "F")
    pSetFont(doc, C.white)
    doc.setFontSize(10)
    doc.setFont("helvetica", "bold")
    doc.text("ANNUAL EXAMINATION REPORT CARD", mmW / 2, y + 5, { align: "center" })

    y += 10

    // Part 1 Label and Instructions
    pSetFont(doc, C.black)
    doc.setFontSize(8)
    if (selectedFormat === "class9_annual") {
      doc.text("PART 1 : SCHOLASTIC AREA", M + 2, y)
      y += 4
      doc.setFont("helvetica", "normal")
      doc.setFontSize(6)
      const instText = "Instructions : Positional Grade is position of the student according to grading scale. The grades have been awarded on a 9-point scale, for scholastic areas. Following is the grading scale :"
      doc.text(instText, M + 2, y)
      y += 3
    } else {
      doc.text("PART 1 : SCHOLASTIC", M + 2, y)
      y += 4
    }

    // Draw Grade Strip for Class 9
    if (selectedFormat === "class9_annual") {
      const gWidth = (mmW - M * 2) / 9
      gradesList.forEach((g, idx) => {
        const gx = M + idx * gWidth
        pSetFill(doc, colorsList[idx])
        doc.rect(gx, y, gWidth, 6, "F")
        pSetFont(doc, C.white)
        doc.setFontSize(5.5)
        doc.setFont("helvetica", "bold")
        doc.text(g, gx + gWidth / 2, y + 2.5, { align: "center" })
        doc.setFont("helvetica", "normal")
        doc.setFontSize(4.5)
        doc.text(g === "E" ? "Failed" : "Next 1/8th", gx + gWidth / 2, y + 5, { align: "center" })
      })
      y += 8
    }

    // AutoTables depending on format
    if (selectedFormat === "class9_annual") {
      const tableBody = activeData.subjects.map(s => [
        s.slno,
        s.name,
        s.code,
        s.periodic,
        s.notebook,
        s.enrich,
        s.annual,
        s.total,
        s.grade
      ])

      tableBody.push([
        { content: "TOTAL MARKS", colSpan: 3, styles: { fontStyle: "bold", halign: "center" } },
        activeData.total_periodic,
        activeData.total_notebook,
        activeData.total_enrich,
        activeData.total_annual,
        activeData.total_total,
        ""
      ])

      autoTable(doc, {
        head: [
          [
            "SLNO",
            "SUBJECTS",
            "SUBJECT CODE",
            "PERIODIC TEST\n(A=10)",
            "NOTE BOOK\n(B=5)",
            "SUBJECT ENRICHMENT\n(C=5)",
            "ANNUAL EXAM\n(D=80)",
            "GRAND TOTAL\n(A+B+C+D=100)",
            "POSITIONAL GRADE"
          ]
        ],
        body: tableBody,
        startY: y,
        margin: { left: M, right: M },
        theme: "grid",
        styles: {
          fontSize: 7,
          cellPadding: { top: 1.5, bottom: 1.5, left: 1.5, right: 1.5 },
          lineColor: [120, 120, 120],
          lineWidth: 0.2,
          textColor: C.black,
          halign: "center"
        },
        headStyles: {
          fillColor: C.maroon,
          textColor: C.white,
          fontStyle: "bold",
          fontSize: 7,
          halign: "center",
          valign: "middle"
        },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { halign: "left" },
          2: { cellWidth: 20 },
          3: { cellWidth: 20 },
          4: { cellWidth: 18 },
          5: { cellWidth: 20 },
          6: { cellWidth: 20 },
          7: { cellWidth: 25 },
          8: { cellWidth: 22 }
        },
        didParseCell: function(data) {
          if (data.row.index === tableBody.length - 1) {
            data.cell.styles.fillColor = C.navyBlue
            data.cell.styles.textColor = C.white
            data.cell.styles.fontStyle = "bold"
          }
        }
      })
    } else {
      // Re-Test Marksheet table
      const tableBody = activeData.subjects.map(s => [
        s.slno,
        s.name,
        s.code,
        s.full_pract,
        s.full_theory,
        s.pass_pract,
        s.pass_theory,
        s.obtain_pract,
        s.obtain_theory,
        s.obtain_total
      ])

      tableBody.push([
        { content: "TOTAL MARKS", colSpan: 3, styles: { fontStyle: "bold", halign: "center" } },
        activeData.total_full_pract,
        activeData.total_full_theory,
        "",
        "",
        activeData.total_obtain_pract,
        activeData.total_obtain_theory,
        activeData.total_obtain_total
      ])

      autoTable(doc, {
        head: [
          [
            { content: "SLNO", rowSpan: 2 },
            { content: "SUBJECT NAME", rowSpan: 2 },
            { content: "SUBJECT CODE", rowSpan: 2 },
            { content: "FULL MARK", colSpan: 2 },
            { content: "PASS MARK", colSpan: 2 },
            { content: "MARK OBTAIN", colSpan: 3 }
          ],
          ["Practical", "Theory", "Practical", "Theory", "Practical", "Theory", "Total"]
        ],
        body: tableBody,
        startY: y,
        margin: { left: M, right: M },
        theme: "grid",
        styles: {
          fontSize: 7.5,
          cellPadding: { top: 1.5, bottom: 1.5, left: 2, right: 2 },
          lineColor: [120, 120, 120],
          lineWidth: 0.2,
          textColor: C.black
        },
        headStyles: {
          fillColor: C.maroon,
          textColor: C.white,
          fontStyle: "bold",
          fontSize: 7.5,
          halign: "center",
          valign: "middle"
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 10 },
          1: { halign: "left" },
          2: { halign: "center", cellWidth: 20 },
          3: { halign: "center", cellWidth: 15 },
          4: { halign: "center", cellWidth: 15 },
          5: { halign: "center", cellWidth: 15 },
          6: { halign: "center", cellWidth: 15 },
          7: { halign: "center", cellWidth: 15 },
          8: { halign: "center", cellWidth: 15 },
          9: { halign: "center", cellWidth: 15 }
        },
        didParseCell: function(data) {
          if (data.row.index === tableBody.length - 1) {
            data.cell.styles.fillColor = C.navyBlue
            data.cell.styles.textColor = C.white
            data.cell.styles.fontStyle = "bold"
          }
        }
      })
    }

    y = doc.lastAutoTable.finalY + 4

    // First attempt box (Only for Re-Test format)
    if (selectedFormat === "retest_marksheet") {
      pSetFill(doc, [238, 228, 208])
      doc.rect(M, y, mmW - M * 2, 7, "F")
      pSetFont(doc, C.black)
      doc.setFontSize(8)
      doc.setFont("helvetica", "bold")
      doc.text(activeData.first_attempt_note, M + 3, y + 4.5)
      y += 11
    }

    // Part 2 Co-scholastic section label
    pSetFont(doc, C.black)
    doc.setFont("helvetica", "bold")
    doc.setFontSize(8)
    doc.text(selectedFormat === "class9_annual" ? "PART 2 : CO-SCHOLASTIC AREA" : "PART 2 : CO-SCHOLASTIC", M + 2, y)

    y += 2

    // Part 2 Columns layout
    const w = mmW - M * 2
    const colW = (w - 4) / 3

    // ── Column 1: Grading Scale & Co-scholastic list ──
    const x1 = M
    pSetDraw(doc, [170, 170, 170])
    doc.rect(x1, y, colW, 40)
    pSetFill(doc, C.navyBlue)
    doc.rect(x1, y, colW, 5, "F")
    pSetFont(doc, C.white)
    doc.setFontSize(7)
    doc.text(selectedFormat === "class9_annual" ? "Grading Scale" : "Grading Scale / Co-Scholastic", x1 + 2, y + 3.5)

    if (selectedFormat === "class9_annual") {
      // Outstanding (A), Very Good (B), Fair (C) design
      pSetFont(doc, C.black)
      doc.setFontSize(5.5)
      const circles = [["A", "Outstanding"], ["B", "Very Good"], ["C", "Fair"]]
      circles.forEach(([lbl, dsc], idx) => {
        const cx = x1 + 10 + idx * 16, cy = y + 10
        doc.circle(cx, cy, 3)
        doc.setFont("helvetica", "bold")
        doc.text(lbl, cx, cy + 1, { align: "center" })
        doc.setFont("helvetica", "normal")
        doc.setFontSize(4)
        doc.text(dsc, cx, cy + 5, { align: "center" })
      })

      // Co-scholastic table header
      pSetFill(doc, C.navyBlue)
      doc.rect(x1, y + 18, colW, 4, "F")
      pSetFont(doc, C.white)
      doc.setFontSize(5.5)
      doc.setFont("helvetica", "bold")
      doc.text("SUBJECTS", x1 + 2, y + 21)
      doc.text("GRADE", x1 + colW - 12, y + 21)

      // Subjects list
      pSetFont(doc, C.black)
      doc.setFont("helvetica", "normal")
      let cy1 = y + 25
      activeData.co_scholastic.forEach(item => {
        doc.text(item.name, x1 + 2, cy1)
        doc.rect(x1 + colW - 12, cy1 - 2, 8, 3) // Empty grade box
        cy1 += 4.5
      })

    } else {
      // Re-Test color strip
      gradesList.forEach((g, idx) => {
        const gx = x1 + 2 + idx * (colW / 9.5)
        pSetFill(doc, colorsList[idx])
        doc.rect(gx, y + 7, 5, 4, "F")
        pSetFont(doc, C.white)
        doc.setFontSize(5)
        doc.text(g, gx + 1, y + 10)
      })

      // Co-scholastic items list
      pSetFont(doc, C.black)
      doc.setFontSize(6.5)
      doc.setFont("helvetica", "normal")
      let cy1 = y + 16
      activeData.co_scholastic.forEach(item => {
        doc.text(`${item.name}`, x1 + 2, cy1)
        doc.setFont("helvetica", "bold")
        doc.text(item.grade, x1 + colW - 6, cy1)
        doc.setFont("helvetica", "normal")
        cy1 += 7
      })
    }

    // ── Column 2: Subject averages ──
    const x2 = M + colW + 2
    doc.rect(x2, y, colW, 40)
    pSetFill(doc, [243, 156, 18]) // Gold header
    doc.rect(x2, y, colW, 5, "F")
    pSetFont(doc, C.white)
    doc.setFontSize(7)
    doc.setFont("helvetica", "bold")
    doc.text(`Subject wise average (Class ${activeData.student_info.st_class}, Sec ${activeData.student_info.st_sec})`, x2 + 2, y + 3.5)

    // Head
    pSetFill(doc, C.navyBlue)
    doc.rect(x2, y + 5, colW, 4, "F")
    pSetFont(doc, C.white)
    doc.setFontSize(6)
    doc.text("SUBJECTS", x2 + 2, y + 8)
    doc.text("Average", x2 + colW - 12, y + 8)

    // Body
    pSetFont(doc, C.black)
    doc.setFont("helvetica", "normal")
    let cy2 = y + 11.5
    const rowStep = selectedFormat === "class9_annual" ? 3.3 : 4.5
    doc.setFontSize(selectedFormat === "class9_annual" ? 5.5 : 6.5)
    activeData.subject_averages.forEach(avg => {
      doc.text(avg.name, x2 + 2, cy2)
      doc.setFont("helvetica", "bold")
      doc.text(String(avg.average), x2 + colW - 8, cy2)
      doc.setFont("helvetica", "normal")
      cy2 += rowStep
    })

    // ── Column 3: Marks/Promotion & Attendance percentages ──
    const x3 = M + colW * 2 + 4
    if (selectedFormat === "class9_annual") {
      // Promotion Status
      doc.rect(x3, y, colW, 18)
      pSetFill(doc, C.maroon)
      doc.rect(x3, y, colW, 5, "F")
      pSetFont(doc, C.white)
      doc.setFontSize(7)
      doc.text("PROMOTION STATUS", x3 + 2, y + 3.5)

      // Attendance
      const ay = y + 21
      doc.rect(x3, ay, colW, 19)
      pSetFill(doc, C.maroon)
      doc.rect(x3, ay, colW, 5, "F")
      pSetFont(doc, C.white)
      doc.setFontSize(7)
      doc.text("ATTENDANCE", x3 + 2, ay + 3.5)
      
      pSetFont(doc, C.black)
      doc.setFontSize(6.5)
      doc.setFont("helvetica", "normal")
      doc.text(`Total Days   : ${activeData.attendance.total_days}`, x3 + 3, ay + 9)
      doc.text(`Days Present: ${activeData.attendance.present_days}`, x3 + 3, ay + 13)

      pSetFill(doc, [224, 112, 32]) // Orange percentage block
      doc.rect(x3 + colW - 13, ay + 7, 10, 10, "F")
      pSetFont(doc, C.white)
      doc.setFont("helvetica", "bold")
      doc.setFontSize(7)
      doc.text(activeData.attendance.percentage, x3 + colW - 8, ay + 13, { align: "center" })

    } else {
      // Re-Test Marksheet Marks Percentage
      doc.rect(x3, y, colW, 18)
      pSetFill(doc, C.maroon)
      doc.rect(x3, y, colW, 5, "F")
      pSetFont(doc, C.white)
      doc.setFontSize(7)
      doc.text("MARKS PERCENTAGE", x3 + 2, y + 3.5)
      
      pSetFont(doc, C.black)
      doc.setFontSize(6.5)
      doc.text(`Practical : ${activeData.marks_percentage.practical}`, x3 + 3, y + 9)
      doc.text(`Theory : ${activeData.marks_percentage.theory}`, x3 + colW / 2 + 2, y + 9)
      pSetFill(doc, [220, 220, 220])
      doc.rect(x3, y + 12, colW, 6, "F")
      pSetFont(doc, C.black)
      doc.setFont("helvetica", "bold")
      doc.text(`Overall Percentage : ${activeData.marks_percentage.overall}`, x3 + 3, y + 16.2)

      // Re-Test Attendance Box
      const ay = y + 21
      doc.rect(x3, ay, colW, 19)
      pSetFill(doc, C.maroon)
      doc.rect(x3, ay, colW, 5, "F")
      pSetFont(doc, C.white)
      doc.setFontSize(7)
      doc.text("ATTENDANCE PERCENTAGE", x3 + 2, ay + 3.5)
      
      pSetFont(doc, C.black)
      doc.setFontSize(10)
      doc.setFont("helvetica", "bold")
      doc.text(activeData.attendance_percentage.percentage, x3 + colW / 2 - 4, ay + 10)

      pSetFill(doc, [254, 237, 222])
      doc.rect(x3, ay + 14, colW, 5, "F")
      pSetFont(doc, [224, 112, 32])
      doc.setFontSize(6.5)
      doc.text(`Min Attendance Required : ${activeData.attendance_percentage.min_required}`, x3 + 3, ay + 17.5)
    }

    y += 44

    // Remarks box
    pSetFont(doc, C.black)
    doc.setFontSize(8)
    doc.setFont("helvetica", "bold")
    doc.text(selectedFormat === "class9_annual" ? "CLASS TEACHER'S REMARKS" : "REMARKS", M + 2, y)
    
    y += 2
    doc.rect(M, y, mmW - M * 2, 14)

    y += 24

    // Signature lines
    pSetDraw(doc, C.black)
    doc.setLineWidth(0.3)
    doc.line(M + 10, y, M + 60, y)
    doc.line(mmW / 2 - 25, y, mmW / 2 + 25, y)
    doc.line(mmW - M - 60, y, mmW - M - 10, y)

    pSetFont(doc, C.black)
    doc.setFontSize(8)
    doc.setFont("helvetica", "normal")
    doc.text("Signature of Guardian", M + 35, y + 4, { align: "center" })
    doc.text("Signature of Class Teacher", mmW / 2, y + 4, { align: "center" })
    doc.text("Signature of Principal", mmW - M - 35, y + 4, { align: "center" })

    // Principal's signature script font mock
    pSetFont(doc, [40, 40, 40])
    doc.setFont("courier", "bolditalic")
    doc.setFontSize(12)
    doc.text("V. Lakhar", mmW - M - 35, y - 4, { align: "center" })

    doc.save(`${selectedFormat === "class9_annual" ? "Class9_Annual" : "ReTest"}_Marksheet_${activeData.student_info.st_name.replace(/\s+/g, "_")}.pdf`)
  }

  const activeData = selectedFormat === "class9_annual"
    ? staticClass9Data
    : selectedFormat === "ma_pre1"
    ? staticMaPre1Data
    : staticReTestData


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Examination" breadcrumbItem="Generate Marksheet" />

          {/* Form and Selection Card */}
          <Card>
            <CardBody>
              <h5 className="card-title mb-4">Select Marksheet Format</h5>
              <Row className="align-items-end">
                <Col lg={6} md={12} className="mb-3">
                  <FormGroup className="mb-0">
                    <Label for="marksheetFormat" className="fw-semibold">
                      Format Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="select"
                      name="marksheetFormat"
                      id="marksheetFormat"
                      value={selectedFormat}
                      onChange={handleFormatChange}
                    >
                      <option value="">-- Select Marksheet Format --</option>
                      {marksheetFormats.map(format => (
                        <option key={format.value} value={format.value}>
                          {format.label} {format.disabled ? "(Under Development)" : ""}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col lg={3} md={6} className="mb-3">
                  <Button
                    color="primary"
                    block
                    onClick={handleGenerate}
                  >
                    <i className="bx bx-cog me-1" />
                    Generate Marksheet
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>

                  {showPreview && (selectedFormat === "retest_marksheet" || selectedFormat === "class9_annual" || selectedFormat === "ma_pre1") && (
            <Card className="mt-4">
              <CardBody className="d-flex flex-column align-items-center">
                <h5 className="card-title text-start w-100 mb-4">Marksheet Preview</h5>

                {/* Simulated Sheet Design Container */}
                <div
                  style={{
                    width: "100%",
                    maxWidth: "850px",
                    border: "2px solid #3a7d44",
                    padding: "20px",
                    background: "#ffffff",
                    fontFamily: "sans-serif",
                    fontSize: "13px",
                    color: "#000000",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
                    borderRadius: "4px",
                  }}
                >
                  {/* Top line strip */}
                  <div className="d-flex justify-content-between mb-2" style={{ fontSize: "11px" }}>
                    <span>Session : <b>{activeData.session_name}</b></span>
                    <span>Print Date : <b>{activeData.print_date}</b></span>
                  </div>

                  {selectedFormat === "ma_pre1" ? (
                    <div style={{ fontFamily: "sans-serif", color: "#000" }}>
                      {/* Page 1 Preview (Outer cover + Observations) */}
                      <div className="border p-3 mb-4 rounded" style={{ backgroundColor: "#fffdf0", borderColor: "#c4a46c" }}>
                        <h6 className="text-uppercase fw-bold text-center mb-3" style={{ color: "#7d0a0a" }}>Booklet Outer Layout (Left Page: General Observations | Right Page: Cover Page)</h6>
                        <Row>
                          {/* Left Page: General Observations */}
                          <Col md={6} className="border-end pr-3">
                            <div className="p-2 mb-2 text-white font-weight-bold text-center" style={{ background: "#c49a6c" }}>GENERAL OBSERVATIONS TERM - 1</div>
                            <table className="table table-bordered table-sm text-start mb-2" style={{ fontSize: "11px" }}>
                              <thead>
                                <tr className="bg-light">
                                  <th>Areas</th>
                                  <th style={{ width: "50px" }} className="text-center">Grade</th>
                                </tr>
                              </thead>
                              <tbody>
                                {activeData.general_observations_t1.map((row, idx) => (
                                  <tr key={idx}>
                                    <td>{row.name}</td>
                                    <td className="text-center font-weight-bold text-danger">{row.grade}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            <div className="mb-2" style={{ fontSize: "11px" }}>
                              <div>Attendance: <b>{activeData.attendance_t1.present} days out of {activeData.attendance_t1.total}</b></div>
                              <div className="mt-1">Remarks: <span className="text-danger">{activeData.remarks_t1}</span></div>
                            </div>
                            <div className="d-flex justify-content-between mt-3 text-muted" style={{ fontSize: "9px" }}>
                              <span>Sig: Class Teacher</span>
                              <span>Parent/Guardian</span>
                              <span>Principal</span>
                            </div>

                            <hr />

                            <div className="p-2 mb-2 text-white font-weight-bold text-center mt-3" style={{ background: "#c49a6c" }}>GENERAL OBSERVATIONS TERM - 2</div>
                            <table className="table table-bordered table-sm text-start mb-2" style={{ fontSize: "11px" }}>
                              <thead>
                                <tr className="bg-light">
                                  <th>Areas</th>
                                  <th style={{ width: "50px" }} className="text-center">Grade</th>
                                </tr>
                              </thead>
                              <tbody>
                                {activeData.general_observations_t2.map((row, idx) => (
                                  <tr key={idx}>
                                    <td>{row.name}</td>
                                    <td className="text-center font-weight-bold text-danger">{row.grade}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            <div className="mb-2" style={{ fontSize: "11px" }}>
                              <div>Attendance: <b>{activeData.attendance_t2.present} days out of {activeData.attendance_t2.total}</b></div>
                              <div className="mt-1">Remarks: <span className="text-danger">{activeData.remarks_t2}</span></div>
                              <div className="mt-1">Promoted to Class: <b>{activeData.promoted_to_class}</b></div>
                            </div>
                            <div className="d-flex justify-content-between mt-3 text-muted" style={{ fontSize: "9px" }}>
                              <span>Sig: Class Teacher</span>
                              <span>Parent/Guardian</span>
                              <span>Principal</span>
                            </div>
                          </Col>

                          {/* Right Page: Cover Page */}
                          <Col md={6} className="pl-3 text-center">
                            <h4 className="font-weight-bold mb-1" style={{ color: "#7d0a0a", fontFamily: "Georgia, serif" }}>South Point School, Guwahati</h4>
                            <div style={{ fontSize: "10px", color: "#666" }}>21, Barsapara Road, Guwahati - 781018</div>
                            <div style={{ fontSize: "10px", color: "#666" }}>Affiliated to CBSE New Delhi, Affiliation No. : 230044</div>
                            <div className="my-2" style={{ borderBottom: "3px solid #7d0a0a" }} />
                            
                            {/* Star Logo simulation */}
                            <div className="mx-auto my-3 rounded-circle border d-flex flex-column justify-content-center align-items-center" style={{ width: "70px", height: "70px", borderColor: "#7d0a0a", borderWidth: "2px" }}>
                              <span style={{ fontSize: "8px", color: "#7d0a0a", fontWeight: "bold" }}>SOUTH POINT</span>
                              <span style={{ fontSize: "12px", color: "#7d0a0a" }}>★</span>
                              <span style={{ fontSize: "8px", color: "#7d0a0a", fontWeight: "bold" }}>GUWAHATI</span>
                            </div>
                            
                            <h3 className="font-weight-bold text-danger" style={{ fontFamily: "Georgia, serif" }}>PROGRESS REPORT</h3>
                            <h6 className="text-muted">Montessori Section ( MA to Pre1 )</h6>
                            
                            <div className="mt-4 font-weight-bold" style={{ fontSize: "12px" }}>ACADEMIC YEAR: {activeData.academic_year}</div>
                            
                            <div className="mt-4 p-3 border text-start" style={{ background: "#fffdf0", borderColor: "#7d0a0a", borderRadius: "4px" }}>
                              <table className="table table-sm table-borderless m-0" style={{ fontSize: "11px" }}>
                                <tbody>
                                  <tr>
                                    <td className="font-weight-bold" style={{ width: "90px" }}>Student Code :</td>
                                    <td>
                                      <div className="d-flex">
                                        {(activeData.student_info.st_code || "").split("").map((c, i) => (
                                          <div key={i} className="border text-center mr-1 font-weight-bold" style={{ width: "16px", height: "18px", lineHeight: "18px", background: "#fff" }}>{c}</div>
                                        ))}
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="font-weight-bold">Student Name :</td>
                                    <td className="border-bottom font-weight-bold">{activeData.student_info.st_name}</td>
                                  </tr>
                                  <tr>
                                    <td className="font-weight-bold">Class :</td>
                                    <td className="border-bottom">{activeData.student_info.st_class}</td>
                                  </tr>
                                  <tr>
                                    <td className="font-weight-bold">Section :</td>
                                    <td className="border-bottom">{activeData.student_info.st_sec}</td>
                                  </tr>
                                  <tr>
                                    <td className="font-weight-bold">Roll :</td>
                                    <td className="border-bottom">{activeData.student_info.roll}</td>
                                  </tr>
                                  <tr>
                                    <td className="font-weight-bold" style={{ fontSize: "9px" }}>Parent Signature :</td>
                                    <td className="border-bottom" style={{ height: "18px" }}></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Col>
                        </Row>
                        <div className="text-center text-white mt-3 p-1 font-weight-bold" style={{ background: "#c49a6c", fontSize: "9px", borderRadius: "2px" }}>
                          NOTE : Parents will return this card to the school duly signed and retained after Annual Examination.
                        </div>
                      </div>

                      {/* Page 2 Preview (Evaluation Records) */}
                      <div className="border p-3 rounded" style={{ backgroundColor: "#fffdf0", borderColor: "#c4a46c" }}>
                        <h6 className="text-uppercase fw-bold text-center mb-3" style={{ color: "#7d0a0a" }}>Booklet Inner Layout (Evaluation Spread)</h6>
                        
                        {/* Grade chart strip */}
                        <div className="p-2 mb-3 text-center border font-weight-bold" style={{ background: "#fff", borderColor: "#c4a46c", fontSize: "11px", color: "#7d0a0a" }}>
                          <span className="mr-3 font-weight-bold">GRADE CHART :</span>
                          <span className="text-success font-weight-bold mr-2">A+: EXCELLENT</span> &nbsp;|&nbsp; 
                          <span className="text-primary font-weight-bold mr-2">A: VERY GOOD</span> &nbsp;|&nbsp; 
                          <span className="text-warning font-weight-bold mr-2">B+: GOOD</span> &nbsp;|&nbsp; 
                          <span className="text-info font-weight-bold mr-2">B: AVERAGE</span> &nbsp;|&nbsp; 
                          <span className="text-danger font-weight-bold">C: SCOPE FOR IMPROVEMENT</span>
                        </div>

                        <Row>
                          {/* Term 1 Evaluation */}
                          <Col md={6} className="border-end pr-2">
                            <div className="text-white p-1 text-center font-weight-bold mb-2" style={{ background: "#c49a6c", fontSize: "12px" }}>EVALUATION RECORD : TERM - 1</div>
                            <table className="table table-bordered table-sm m-0" style={{ fontSize: "11px" }}>
                              <thead className="bg-light text-center">
                                <tr>
                                  <th>AREAS OF ASSESSMENT</th>
                                  <th style={{ width: "60px" }}>GRADE</th>
                                </tr>
                              </thead>
                              <tbody>
                                {activeData.evaluations.map((item, idx) => (
                                  <tr key={idx}>
                                    <td>{item.slno}. {item.name}</td>
                                    <td className="text-center font-weight-bold text-danger bg-white">{item.t1}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </Col>

                          {/* Term 2 Evaluation */}
                          <Col md={6} className="pl-2">
                            <div className="text-white p-1 text-center font-weight-bold mb-2" style={{ background: "#c49a6c", fontSize: "12px" }}>EVALUATION RECORD : TERM - 2</div>
                            <table className="table table-bordered table-sm m-0" style={{ fontSize: "11px" }}>
                              <thead className="bg-light text-center">
                                <tr>
                                  <th>AREAS OF ASSESSMENT</th>
                                  <th style={{ width: "60px" }}>GRADE</th>
                                </tr>
                              </thead>
                              <tbody>
                                {activeData.evaluations.map((item, idx) => (
                                  <tr key={idx}>
                                    <td>{item.slno}. {item.name}</td>
                                    <td className="text-center font-weight-bold text-danger bg-white">{item.t2}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  ) : (
                    <>
                      {/* School Header */}
                      <div
                        style={{
                          background: "#7d0a0a",
                          color: "#ffffff",
                          textAlign: "center",
                          padding: "12px 10px",
                          borderRadius: "2px",
                        }}
                      >
                        <div style={{ fontSize: "12px" }}>{SCHOOL.established}</div>
                        <h3 className="m-0 text-white font-weight-bold" style={{ letterSpacing: "1px" }}>
                          {SCHOOL.name}
                        </h3>
                      </div>

                      {/* Info Strip */}
                      <div
                        className="text-center py-2 position-relative"
                        style={{ borderBottom: "1px solid #ddd", fontSize: "11px" }}
                      >
                        {/* Logos simulation */}
                        <div
                          className="d-flex justify-content-between align-items-center px-4"
                          style={{ minHeight: "50px" }}
                        >
                          <div
                            style={{
                              width: "55px",
                              height: "55px",
                              border: "1px solid #ccc",
                              display: "grid",
                              placeItems: "center",
                              fontSize: "8px",
                              color: "#888",
                            }}
                          >
                            CBSE Logo
                          </div>
                          <div style={{ flex: 1, padding: "0 10px" }}>
                            <div className="font-weight-bold mb-1">{SCHOOL.affiliation}</div>
                            <div>
                              <span style={{ color: "#7d0a0a", fontWeight: "bold" }}>Address : </span>
                              {SCHOOL.address} &nbsp;|&nbsp;
                              <span style={{ color: "#7d0a0a", fontWeight: "bold" }}>Phone : </span>
                              {SCHOOL.phone}
                            </div>
                            <div className="mt-1">
                              <span style={{ color: "#7d0a0a", fontWeight: "bold" }}>Email : </span>
                              {SCHOOL.email} &nbsp;|&nbsp;
                              <span style={{ color: "#7d0a0a", fontWeight: "bold" }}>Website : </span>
                              {SCHOOL.website}
                            </div>
                          </div>
                          <div
                            style={{
                              width: "55px",
                              height: "55px",
                              border: "1px solid #ccc",
                              display: "grid",
                              placeItems: "center",
                              fontSize: "8px",
                              color: "#888",
                            }}
                          >
                            School Logo
                          </div>
                        </div>
                      </div>

                      {/* Student Details Title */}
                      <div className="mt-3">
                        <span
                          style={{
                            background: "#7d0a0a",
                            color: "#fff",
                            padding: "4px 10px",
                            fontWeight: "bold",
                            fontSize: "12px",
                            borderRadius: "2px 2px 0 0",
                          }}
                        >
                          Student Details
                        </span>
                      </div>

                      {/* Student Details Table Grid */}
                      <div
                        style={{
                          border: "1px solid #7d0a0a",
                          padding: "15px",
                          borderRadius: "0 2px 2px 2px",
                          background: "#fafafa",
                        }}
                      >
                        <Row>
                          <Col md={9}>
                            <Row className="mb-2">
                              <Col sm={4} className="font-weight-bold text-muted">Student's Name :</Col>
                              <Col sm={8} className="font-weight-bold">{activeData.student_info.st_name}</Col>
                            </Row>
                            <Row className="mb-2">
                              <Col sm={4} className="font-weight-bold text-muted">Father's Name :</Col>
                              <Col sm={8} className="font-weight-bold">{activeData.student_info.father_name}</Col>
                            </Row>
                            <Row className="mb-2">
                              <Col sm={4} className="font-weight-bold text-muted">Mother's Name :</Col>
                              <Col sm={8} className="font-weight-bold">{activeData.student_info.mother_name}</Col>
                            </Row>
                            <Row className="mb-2">
                              <Col sm={4} className="font-weight-bold text-muted">Address :</Col>
                              <Col sm={8} className="font-weight-bold" style={{ fontSize: "12px" }}>
                                {activeData.student_info.address}
                              </Col>
                            </Row>
                          </Col>
                          <Col md={3} className="d-flex flex-column align-items-center justify-content-between">
                            <div
                              style={{
                                width: "90px",
                                height: "110px",
                                border: "1px solid #bbb",
                                display: "grid",
                                placeItems: "center",
                                background: "#eaeaea",
                                color: "#888",
                                fontSize: "12px",
                              }}
                            >
                              {activeData.student_info.profile_pic ? "Photo" : "No Photo Available"}
                            </div>
                            <div className="mt-3 text-start w-100" style={{ fontSize: "12px" }}>
                              <div>Code : <b>{activeData.student_info.st_code}</b></div>
                              <div>Class : <b>{activeData.student_info.st_class}</b></div>
                              <div>Section : <b>{activeData.student_info.st_sec}</b></div>
                              <div>DOB : <b>{activeData.student_info.dob}</b></div>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      {/* Title band */}
                      <div
                        className="text-center py-2 my-4 text-white font-weight-bold"
                        style={{
                          background: "#7d5032",
                          fontSize: "15px",
                          letterSpacing: "1px",
                          borderRadius: "2px",
                        }}
                      >
                        ANNUAL EXAMINATION REPORT CARD
                      </div>

                      {/* Part 1: Scholastic */}
                      <div className="font-weight-bold mb-1" style={{ fontSize: "13px" }}>
                        {selectedFormat === "class9_annual" ? "PART 1 : SCHOLASTIC AREA" : "PART 1 : SCHOLASTIC"}
                      </div>
                      
                      {selectedFormat === "class9_annual" && (
                        <div className="mb-3" style={{ fontSize: "11px", color: "#333" }}>
                          <div>Instructions : Positional Grade is position of the student according to grading scale. The grades have been awarded on a 9-point scale, for scholastic areas. Following is the grading scale:</div>
                          
                          {/* Scale display */}
                          <div className="d-flex w-100 mt-2" style={{ border: "1px solid #bbb", borderRadius: "2px" }}>
                            {gradesList.map((g, idx) => (
                              <div
                                key={g}
                                style={{
                                  flex: 1,
                                  background: `rgb(${colorsList[idx].join(",")})`,
                                  color: "#fff",
                                  padding: "4px 2px",
                                  textAlign: "center",
                                  fontSize: "10px",
                                  fontWeight: "bold",
                                }}
                              >
                                <div style={{ fontSize: "11px" }}>{g}</div>
                                <div style={{ fontSize: "8px", fontWeight: "normal", opacity: 0.9 }}>
                                  {g === "E" ? "Failed" : "Top 1/8th"}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Scholastic Table */}
                      {selectedFormat === "class9_annual" ? (
                        <table className="table table-bordered text-center mb-3" style={{ fontSize: "12px" }}>
                          <thead style={{ background: "#7d0a0a", color: "#fff" }}>
                            <tr>
                              <th className="align-middle text-white">SLNO</th>
                              <th className="align-middle text-white text-start">SUBJECTS</th>
                              <th className="align-middle text-white">SUBJECT CODE</th>
                              <th className="text-white">PERIODIC TEST<br /><small>A=10</small></th>
                              <th className="text-white">NOTE BOOK<br /><small>B=5</small></th>
                              <th className="text-white">SUBJECT ENRICHMENT<br /><small>C=5</small></th>
                              <th className="text-white">ANNUAL EXAM<br /><small>D=80</small></th>
                              <th className="text-white">GRAND TOTAL<br /><small>A+B+C+D=100</small></th>
                              <th className="align-middle text-white">POSITIONAL GRADE</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activeData.subjects.map(s => (
                              <tr key={s.slno}>
                                <td>{s.slno}</td>
                                <td className="text-start font-weight-bold">{s.name}</td>
                                <td>{s.code}</td>
                                <td>{s.periodic}</td>
                                <td>{s.notebook}</td>
                                <td>{s.enrich}</td>
                                <td>{s.annual}</td>
                                <td className="font-weight-bold" style={{ backgroundColor: "#fef9c3" }}>{s.total}</td>
                                <td className="font-weight-bold">{s.grade}</td>
                              </tr>
                            ))}
                            <tr style={{ background: "#020255", color: "#fff", fontWeight: "bold" }}>
                              <td colSpan={3} className="text-white text-center">TOTAL MARKS</td>
                              <td className="text-white">{activeData.total_periodic}</td>
                              <td className="text-white">{activeData.total_notebook}</td>
                              <td className="text-white">{activeData.total_enrich}</td>
                              <td className="text-white">{activeData.total_annual}</td>
                              <td className="text-white" style={{ backgroundColor: "#1e3a8a" }}>{activeData.total_total}</td>
                              <td className="text-white">-</td>
                            </tr>
                          </tbody>
                        </table>
                      ) : (
                        <table className="table table-bordered text-center mb-3" style={{ fontSize: "12px" }}>
                          <thead style={{ background: "#7d0a0a", color: "#fff" }}>
                            <tr>
                              <th rowSpan={2} className="align-middle text-white">SLNO</th>
                              <th rowSpan={2} className="align-middle text-white text-start">SUBJECT NAME</th>
                              <th rowSpan={2} className="align-middle text-white">SUBJECT CODE</th>
                              <th colSpan={2} className="text-white">FULL MARK</th>
                              <th colSpan={2} className="text-white">PASS MARK</th>
                              <th colSpan={3} className="text-white">MARK OBTAIN</th>
                            </tr>
                            <tr>
                              <th className="text-white">Practical</th>
                              <th className="text-white">Theory</th>
                              <th className="text-white">Practical</th>
                              <th className="text-white">Theory</th>
                              <th className="text-white">Practical</th>
                              <th className="text-white">Theory</th>
                              <th className="text-white">Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {activeData.subjects.map(s => (
                              <tr key={s.slno}>
                                <td>{s.slno}</td>
                                <td className="text-start font-weight-bold">{s.name}</td>
                                <td>{s.code}</td>
                                <td>{s.full_pract}</td>
                                <td>{s.full_theory}</td>
                                <td>{s.pass_pract}</td>
                                <td>{s.pass_theory}</td>
                                <td>{s.obtain_pract}</td>
                                <td style={{ color: String(s.obtain_theory).includes("RT") ? "#c0392b" : undefined, fontWeight: "bold" }}>
                                  {s.obtain_theory}
                                </td>
                                <td className="font-weight-bold" style={{ backgroundColor: "#fef9c3" }}>{s.obtain_total}</td>
                              </tr>
                            ))}
                            <tr style={{ background: "#020255", color: "#fff", fontWeight: "bold" }}>
                              <td colSpan={3} className="text-white">TOTAL MARKS</td>
                              <td className="text-white">{activeData.total_full_pract}</td>
                              <td className="text-white">{activeData.total_full_theory}</td>
                              <td className="text-white">-</td>
                              <td className="text-white">-</td>
                              <td className="text-white">{activeData.total_obtain_pract}</td>
                              <td className="text-white">{activeData.total_obtain_theory}</td>
                              <td className="text-white" style={{ backgroundColor: "#1e3a8a" }}>{activeData.total_obtain_total}</td>
                            </tr>
                          </tbody>
                        </table>
                      )}

                      {/* First Attempt Box (Only for Re-Test format) */}
                      {selectedFormat === "retest_marksheet" && (
                        <div
                          className="p-2 mb-4 font-weight-bold text-center"
                          style={{ background: "#eee4d0", border: "1px solid #d4c4a8", borderRadius: "2px" }}
                        >
                          {activeData.first_attempt_note}
                        </div>
                      )}

                      {/* Part 2: Co-scholastic area */}
                      <div className="font-weight-bold mb-2" style={{ fontSize: "13px" }}>
                        {selectedFormat === "class9_annual" ? "PART 2 : CO-SCHOLASTIC AREA" : "PART 2 : CO-SCHOLASTIC"}
                      </div>
                      <Row className="mb-4">
                        {/* Col 1: Grading scale & table */}
                        <Col md={4} className="pr-1">
                          <div style={{ border: "1px solid #ccc", height: "100%" }}>
                            <div className="text-white p-1 text-center font-weight-bold" style={{ background: "#020255", fontSize: "11px" }}>
                              {selectedFormat === "class9_annual" ? "Grading Scale" : "Grading Scale / Co-Scholastic"}
                            </div>
                            <div className="p-2">
                              {selectedFormat === "class9_annual" ? (
                                <>
                                  {/* 3 scale circles */}
                                  <div className="d-flex justify-content-around mb-3 mt-1" style={{ fontSize: "9px" }}>
                                    <div className="text-center">
                                      <div className="rounded-circle border border-dark mx-auto d-grid place-items-center font-weight-bold" style={{ width: "22px", height: "22px", lineHeight: "20px" }}>A</div>
                                      <span className="font-weight-bold">Outstanding</span>
                                    </div>
                                    <div className="text-center">
                                      <div className="rounded-circle border border-dark mx-auto d-grid place-items-center font-weight-bold" style={{ width: "22px", height: "22px", lineHeight: "20px" }}>B</div>
                                      <span className="font-weight-bold">Very Good</span>
                                    </div>
                                    <div className="text-center">
                                      <div className="rounded-circle border border-dark mx-auto d-grid place-items-center font-weight-bold" style={{ width: "22px", height: "22px", lineHeight: "20px" }}>C</div>
                                      <span className="font-weight-bold">Fair</span>
                                    </div>
                                  </div>
                                  <table className="table table-sm m-0" style={{ fontSize: "11px" }}>
                                    <thead style={{ background: "#020255", color: "#fff" }}>
                                      <tr>
                                        <th className="text-white">SUBJECTS</th>
                                        <th className="text-white text-end">GRADE</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {activeData.co_scholastic.map((c, idx) => (
                                        <tr key={idx}>
                                          <td>{c.name}</td>
                                          <td className="text-end">
                                            <div className="border border-dark d-inline-block" style={{ width: "24px", height: "16px" }} />
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </>
                              ) : (
                                <>
                                  <div className="d-flex justify-content-between mb-2">
                                    {gradesList.map((g, idx) => (
                                      <div
                                        key={g}
                                        style={{
                                          background: `rgb(${colorsList[idx].join(",")})`,
                                          color: "#fff",
                                          fontSize: "9px",
                                          padding: "2px 4px",
                                          textAlign: "center",
                                          borderRadius: "1px",
                                          fontWeight: "bold"
                                        }}
                                      >
                                        {g}
                                      </div>
                                    ))}
                                  </div>
                                  <table className="table table-sm table-striped m-0" style={{ fontSize: "11px" }}>
                                    <tbody>
                                      {activeData.co_scholastic.map((c, idx) => (
                                        <tr key={idx}>
                                          <td>{c.name}</td>
                                          <td className="font-weight-bold text-end">{c.grade}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </>
                              )}
                            </div>
                          </div>
                        </Col>

                        {/* Col 2: Subject averages */}
                        <Col md={4} className="px-1">
                          <div style={{ border: "1px solid #ccc", height: "100%", maxHeight: "250px", overflowY: "auto" }}>
                            <div className="text-white p-1 text-center font-weight-bold" style={{ background: "#f39c12", fontSize: "11px" }}>
                              Subject wise average (Class {sd.st_class}, Sec {sd.st_sec})
                            </div>
                            <table className="table table-sm table-striped m-0" style={{ fontSize: "11px" }}>
                              <thead style={{ background: "#020255", color: "#fff" }}>
                                <tr>
                                  <th className="text-white">SUBJECTS</th>
                                  <th className="text-white text-end">Average</th>
                                </tr>
                              </thead>
                              <tbody>
                                {activeData.subject_averages.map((avg, idx) => (
                                  <tr key={idx}>
                                    <td>{avg.name}</td>
                                    <td className="font-weight-bold text-end">{avg.average}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </Col>

                        {/* Col 3: Percentages / Promotion Status */}
                        <Col md={4} className="pl-1 d-flex flex-column justify-content-between">
                          {selectedFormat === "class9_annual" ? (
                            <>
                              {/* Promotion status */}
                              <div className="mb-2" style={{ border: "1px solid #ccc", flex: 1 }}>
                                <div className="text-white p-1 text-center font-weight-bold" style={{ background: "#7d0a0a", fontSize: "11px" }}>
                                  PROMOTION STATUS
                                </div>
                                <div className="p-3 text-center font-weight-bold text-success" style={{ minHeight: "50px" }}>
                                  {activeData.promotion_status || "—"}
                                </div>
                              </div>

                              {/* Attendance */}
                              <div style={{ border: "1px solid #ccc" }}>
                                <div className="text-white p-1 text-center font-weight-bold" style={{ background: "#7d0a0a", fontSize: "11px" }}>
                                  ATTENDANCE
                                </div>
                                <div className="p-2 d-flex justify-content-between align-items-center" style={{ fontSize: "11px" }}>
                                  <div>
                                    <div>Total Days: <b>{activeData.attendance.total_days}</b></div>
                                    <div className="mt-1">Days Present: <b>{activeData.attendance.present_days}</b></div>
                                  </div>
                                  <div
                                    className="p-2 text-white font-weight-bold text-center"
                                    style={{ background: "#e07020", borderRadius: "3px", minWidth: "40px" }}
                                  >
                                    {activeData.attendance.percentage}
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {/* Marks Pct */}
                              <div className="mb-2" style={{ border: "1px solid #ccc" }}>
                                <div className="text-white p-1 text-center font-weight-bold" style={{ background: "#7d0a0a", fontSize: "11px" }}>
                                  MARKS PERCENTAGE
                                </div>
                                <div className="p-2" style={{ fontSize: "11px" }}>
                                  <div className="d-flex justify-content-between mb-1">
                                    <span>Practical: <b>{staticReTestData.marks_percentage.practical}</b></span>
                                    <span>Theory: <b>{staticReTestData.marks_percentage.theory}</b></span>
                                  </div>
                                  <div className="text-center p-1 font-weight-bold mt-1" style={{ background: "#ddd" }}>
                                    Overall Percentage: {staticReTestData.marks_percentage.overall}
                                  </div>
                                </div>
                              </div>

                              {/* Attendance Pct */}
                              <div style={{ border: "1px solid #ccc" }}>
                                <div className="text-white p-1 text-center font-weight-bold" style={{ background: "#7d0a0a", fontSize: "11px" }}>
                                  ATTENDANCE PERCENTAGE
                                </div>
                                <div className="p-2 text-center" style={{ fontSize: "11px" }}>
                                  <h4 className="m-0 font-weight-bold text-primary">{staticReTestData.attendance_percentage.percentage}</h4>
                                  <div className="p-1 font-weight-bold mt-2" style={{ background: "#fef3c7", color: "#d97706", fontSize: "10px" }}>
                                    Min Attendance Required : {staticReTestData.attendance_percentage.min_required}
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </Col>
                      </Row>

                      {/* REMARKS Box */}
                      <div className="mb-4">
                        <div className="font-weight-bold mb-1">
                          {selectedFormat === "class9_annual" ? "CLASS TEACHER'S REMARKS" : "REMARKS"}
                        </div>
                        <div style={{ border: "1px solid #ccc", minHeight: "50px", padding: "10px", background: "#fcfcfc" }}>
                          {activeData.remarks || "No remarks entered."}
                        </div>
                      </div>

                      {/* Signatures */}
                      <div className="d-flex justify-content-between text-center mt-5 pt-3" style={{ borderTop: "1px solid #eee", fontSize: "12px" }}>
                        <div style={{ width: "200px" }}>
                          <div className="border-top border-dark pt-1 mx-auto" style={{ width: "150px" }}>
                            Signature of Guardian
                          </div>
                        </div>
                        <div style={{ width: "200px" }}>
                          <div className="border-top border-dark pt-1 mx-auto" style={{ width: "150px" }}>
                            Signature of Class Teacher
                          </div>
                        </div>
                        <div style={{ width: "200px" }}>
                          {/* Principal Signature Mock script */}
                          <div style={{ fontFamily: "cursive", fontSize: "16px", height: "20px", color: "#333", fontWeight: "bold" }}>
                            V. Lakhar
                          </div>
                          <div className="border-top border-dark pt-1 mx-auto" style={{ width: "150px" }}>
                            Signature of Principal
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>


                {/* Download Button */}
                <div className="mt-4">
                  <Button
                    color="success"
                    size="lg"
                    onClick={handleDownload}
                  >
                    <i className="bx bx-download me-1" />
                    Download Marksheet PDF
                  </Button>
                </div>
              </CardBody>
            </Card>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default GenerateTestMarksheet
